import { useGetDisplayNameStore } from './store';
import { DisplayNameControlKeys, DisplayNamePerson, DisplayNameOptions, ResolvedDisplayName } from './types';

const formatName = (person: DisplayNamePerson, value: DisplayNameControlKeys) => {
  const firstName =
    value === DisplayNameControlKeys.PREFERRED_NAME && person?.preferredName
      ? person?.preferredName
      : person?.firstName;

  return `${firstName} ${person?.lastName}`.trim();
};

const resolveDisplayName = (
  value: DisplayNameControlKeys,
  person: DisplayNamePerson,
  options?: DisplayNameOptions
): ResolvedDisplayName => {
  const firstName = person?.firstName || '';
  const lastName = person?.lastName || '';
  const preferredName = person?.preferredName || '';

  const fullName = formatName(person, value);
  const legalFullName = `${firstName} ${lastName}`.trim();

  const legalFields = {
    legalFirstName: firstName,
    legalLastName: lastName,
    legalName: legalFullName,
  };

  const legalName = {
    firstName: firstName,
    lastName: lastName,
    fullName: fullName,
    isPreferred: false,
    ...legalFields,
  };

  if (options?.alwaysUseLegalName && person) {
    return legalName;
  }
  if (value === DisplayNameControlKeys.PREFERRED_NAME && preferredName) {
    return {
      firstName: preferredName,
      lastName: lastName,
      fullName: fullName,
      preferredName: preferredName,
      isPreferred: true,
      ...legalFields,
    };
  }
  return legalName;
};

export const getDisplayName = (person: DisplayNamePerson, options?: DisplayNameOptions): ResolvedDisplayName => {
  const value = useGetDisplayNameStore.getState().displayNamePref;
  return resolveDisplayName(value, person, options);
};

export const useGetDisplayName = ({ person, options }: { person: DisplayNamePerson; options?: DisplayNameOptions }) => {
  const value = useGetDisplayNameStore((state) => state.displayNamePref);

  return resolveDisplayName(value, person, options);
};
